import { render, staticRenderFns } from "./dados_cadastrais.vue?vue&type=template&id=55ca399c&scoped=true&"
import script from "./dados_cadastrais.vue?vue&type=script&lang=js&"
export * from "./dados_cadastrais.vue?vue&type=script&lang=js&"
import style0 from "./dados_cadastrais.vue?vue&type=style&index=0&id=55ca399c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca399c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
